var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('li',{staticClass:"nav-item dropdown-user"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_c('i',{staticClass:"icon-switch2"}),_vm._v(" Logout")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }